import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Row, Col, OverlayTrigger, Tooltip,
} from 'react-bootstrap';
import groupBy from 'lodash.groupby';
import update from 'immutability-helper';
import ReferralOptions from './ReferralOptions';
import ReferralsList from './ReferralsList';
import ReferralTerms from './ReferralTerms';
import whiteboardImg from '../../../assets/images/whiteboard-human.svg';
import { analyticsTrack } from '../../analyticsUtils';
import './ReferralsIndexContainer.scss';

function EmptyReferralsSection() {
  return (
    <Row>
      <Col md={8} sm={6}>
        <div className="no-referrals">
          <h1 className="hero-header my-referrals">My Invites</h1>

          <div className="body-text-1">
            <div>You haven&#39;t invited anybody yet.</div>
            <div>The progress of your referrals will appear here.</div>
          </div>
        </div>
      </Col>

      <Col md={4} sm={6}>
        <img src={whiteboardImg} className="d-none d-sm-block" alt="" height="300" />
      </Col>
    </Row>
  );
}

class ReferralsIndexContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInviteModal: this.props.returnFromLinkedIn,
      whichInviteModal: this.props.isConsultant ? 'consultant' : 'employer',
      referrals: props.referrals,
      showTermsModal: false,
    };

    this.handleShowInviteModal = this.handleShowInviteModal.bind(this);
    this.handleCloseInviteModal = this.handleCloseInviteModal.bind(this);

    this.handleShowTermsModal = this.handleShowTermsModal.bind(this);
    this.handleCloseTermsModal = this.handleCloseTermsModal.bind(this);

    this.addReferrals = this.addReferrals.bind(this);
  }

  handleShowInviteModal(whichModal) {
    const { isConsultant } = this.props;
    analyticsTrack('Clicked on Refer Now', {
      location: `${isConsultant ? 'Consultant' : 'Employer'} Referral Program`,
      referred_user_type: whichModal,
    });
    this.setState({
      showInviteModal: true,
      whichInviteModal: whichModal,
    });
  }

  handleCloseInviteModal() {
    this.setState({ showInviteModal: false });
  }

  handleShowTermsModal() {
    this.setState({ showTermsModal: true });
  }

  handleCloseTermsModal() {
    this.setState({ showTermsModal: false });
  }

  addReferrals(newReferrals) {
    const { referrals } = this.state;
    this.setState({ referrals: update(referrals, { $unshift: newReferrals }) });
  }

  renderReferralButtonAndModal(
    modalType,
    buttonText,
    buttonStyle,
    showSocialMediaShareButtons,
    colorScheme = null,
  ) {
    const { isConsultant } = this.props;
    const { showInviteModal, whichInviteModal } = this.state;
    return (
      <div className="mb-2">
        <button className={`btn btn-${buttonStyle} bigger-button mt-5 refer-${modalType}s`} onClick={() => this.handleShowInviteModal(modalType)}>
          {buttonText}
        </button>
        <Modal
          show={showInviteModal && modalType === whichInviteModal}
          onHide={this.handleCloseInviteModal}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <ReferralOptions
              {...this.props}
              addReferrals={this.addReferrals}
              location={`${isConsultant ? 'Consultant' : 'Employer'} Referral Program`}
              referredUserType={modalType}
              isConsultant={isConsultant}
              showSocialMediaShareButtons={showSocialMediaShareButtons}
              colorScheme={colorScheme}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  renderReferralsLists() {
    const { referrals } = this.state;
    const { isConsultant, csrfToken } = this.props;

    if (!referrals || !referrals.length) {
      return (<EmptyReferralsSection />);
    }
    const sortedReferrals = groupBy(referrals, 'referred_user_type');
    return (
      <div className="all-referrals">
        <h1 className="hero-header my-referrals">My Referrals</h1>

        <div className="d-none d-sm-block body-text-1 mb-24">
          Follow your referrals&#39; progress and be part of their success.
        </div>

        {isConsultant
          ? (
            <div>
              <div className="mb-70">
                <ReferralsList
                  referrals={sortedReferrals.consultant || []}
                  csrfToken={csrfToken}
                  userType="consultant"
                  headerTitle={`Consultant Referrals (${sortedReferrals.consultant && sortedReferrals.consultant.length})`}
                />
              </div>
              <ReferralsList
                referrals={sortedReferrals.employer || []}
                csrfToken={csrfToken}
                userType="employer"
                headerTitle={`Employer Referrals (${sortedReferrals.employer && sortedReferrals.employer.length})`}
              />
            </div>
          )
          : (
            <ReferralsList
              referrals={referrals}
              csrfToken={csrfToken}
              userType="employer"
            />
          )}
      </div>
    );
  }

  render() {
    const { isConsultant } = this.props;

    return (
      <div className="g-column--between style-guide">
        <div className="referrals-banner text-center">
          <h1 className="hero-header bold  mb-3 ">
            <div className="d-none d-sm-block">
              {isConsultant
                ? 'Connect consultants with relevant projects matching their interest and expertise.'
                : 'Connect innovative life science companies with top-tier talent.'}
              <br />
            </div>
            {!isConsultant && 'Accelerate the life science industry!'}
          </h1>

          <h1 className="subtext mb-4 g-row g-row--centered">
            {isConsultant
              ? 'Invite consultants to join Clora & earn $500 when they are hired!'
              : 'Get an employer to publish a project & earn $500 when it matches with a consultant!'}
            { isConsultant
              && (
              <OverlayTrigger
                placement="right"
                delay={{ show: 100 }}
                overlay={(
                  <Tooltip id="referral-tooltip">
                    You can invite both consultants and employers. Earn $500 when a consultant you
                    invited is hired for their first project and/or when an employer hires their
                    first consultant.
                  </Tooltip>
                )}
              >
                <i className="fas fa-info-circle" />
              </OverlayTrigger>
              )}
          </h1>

          {isConsultant
            ? (
              <div className="referrals-buttons">
                <div className="g-row">
                  <div className="g-flex-6 text-center employer-button-modal">
                    {this.renderReferralButtonAndModal('employer', 'Invite Employer', 'secondary', false, 'purple')}
                  </div>
                  <div className="g-flex-6 text-center consultant-button-modal">
                    {this.renderReferralButtonAndModal('consultant', 'Invite Consultant', 'primary', true, 'green')}
                  </div>
                </div>
              </div>
            )
            : this.renderReferralButtonAndModal('employer', 'Refer Now!', 'primary rounded-cta', true)}
        </div>

        <div className="white-background g-column g-column--centered">
          <div className="container">
            <div className="referrals-container">
              {this.renderReferralsLists()}
            </div>

            <div className="referrals-explanation mt-4 mb-5">
              <h1 className="hero-header mb-3">
                {isConsultant ? 'How it works' : 'How referrals work'}
                <span className="body-text-2 normal-weight ps-3">
                  <a
                    href="# "
                    id={`${isConsultant ? 'consultant' : 'employer'}-referral-terms`}
                    className=" p-0"
                    onClick={this.handleShowTermsModal}
                  >
                    Read terms
                  </a>
                </span>
              </h1>

              <Row className="g-flex-justify-space-between g-row">
                <Col md={3}>
                  <div className="g-row--always">
                    <h1 className="pe-3 hero-header">1.</h1>
                    <div className="explain-text">
                      <h1 className="mb-2">
                        {isConsultant ? 'Invite your network' : 'Refer an employer'}
                      </h1>
                      <div className="body-text-2">
                        Share your personal referral link with your network.
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={1} />

                <Col md={3}>
                  <div className="g-row--always">
                    <h1 className="pr-10 hero-header">2.</h1>
                    <div className="explain-text">
                      <h1 className="mb-2">Track their progress</h1>
                      <div className="body-text-2">
                        Wait for your referral to accept your invite
                        and
                        {' '}
                        {isConsultant
                          ? 'apply to a project.'
                          : 'publish a project in our platform.'}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={1} />

                <Col md={3}>
                  <div className="g-row--always">
                    <h1 className="hero-header pe-3">3.</h1>
                    <div className="explain-text">
                      <h1 className="mb-2">Earn $500</h1>
                      <div className="body-text-2">
                        {isConsultant
                          ? 'When a consultant you invited is hired for their first project and/or when an employer hires their first consultant'
                          : "Get paid when your referral's project matches a consultant."}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <Modal
          show={this.state.showTermsModal}
          onHide={this.handleCloseTermsModal}
          size="lg"
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <ReferralTerms isEmployer={!isConsultant} />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ReferralsIndexContainer.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referrals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  returnFromLinkedIn: PropTypes.bool,
  isConsultant: PropTypes.bool,
};

ReferralsIndexContainer.defaultProps = {
  returnFromLinkedIn: false,
  isConsultant: false,
};

export default ReferralsIndexContainer;
